import React, { useState, useEffect } from 'react'
import { motion } from 'motion/react'
import type { FieldValues } from '../../fieldTypes'
import { twColorToHex } from '../../../utils/twColor'

export function LineDrawing({ values = {} }: { values?: FieldValues }) {
  const [key, setKey] = useState(0)
  const strokeColor = twColorToHex(values.strokeColor ?? 'bg-indigo-500')
  const strokeWidth = values.strokeWidth ?? 2.5
  const duration = values.duration ?? 2
  const circleColor = twColorToHex(values.circleColor ?? 'bg-purple-500')
  const circleDelay = values.circleDelay ?? 0.8

  useEffect(() => {
    const interval = setInterval(() => setKey((k) => k + 1), 4000)
    return () => clearInterval(interval)
  }, [])

  return (
    <div className="flex items-center justify-center h-full">
      <motion.svg
        key={key}
        width="80"
        height="80"
        viewBox="0 0 80 80"
        fill="none"
      >
        <motion.polygon
          points="40,8 72,68 8,68"
          stroke={strokeColor}
          strokeWidth={strokeWidth}
          strokeLinejoin="round"
          fill="none"
          initial={{ pathLength: 0 }}
          animate={{ pathLength: 1 }}
          transition={{ duration, ease: 'easeInOut' }}
        />
        <motion.circle
          cx="40"
          cy="48"
          r="12"
          stroke={circleColor}
          strokeWidth={Math.max(strokeWidth - 0.5, 1)}
          fill="none"
          initial={{ pathLength: 0 }}
          animate={{ pathLength: 1 }}
          transition={{ duration: duration * 0.75, delay: circleDelay, ease: 'easeInOut' }}
        />
      </motion.svg>
    </div>
  )
}
